import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import { FaRegCircle, FaRegCircleCheck } from "react-icons/fa6";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ConfirmDeleteMcpModal = ({
    setPopupMex,
    account_id,
    show,
    handleClose,
    org_id, 
    mcp_id,
    fetchData = null
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [loadingDeleteMcp, setLoadingDeleteMcp] = useState(false)
    const [inputValue, setInputValue] = useState("")
    const [checkCopy, setCheckCopy] = useState(false)
    const [checkedItems, setCheckedItems] = useState([false, false, false, false, false]);
    const [statusDelete, setStatusDelete] = useState(false)

    const toggleCheck = (index) => {
        const newChecked = [...checkedItems];
        newChecked[index] = !newChecked[index];
        setCheckedItems(newChecked);
    };

    const handleDeleteMcp = async () => {
        setStatusDelete(false)
        setErrorMessage({ message: "", display: false })

        if (!checkedItems.every(Boolean)) {
            setErrorMessage({ message: t.abilities.all_warnings_checked , display: true });
            return;
        }

        if (inputValue != mcp_id) {
            setErrorMessage({ message: `${t.type_confirm} "${mcp_id}"`, display: true });
            return;
        }

        setLoadingDeleteMcp(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/delete_mcp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    mcp_id
                }),
            });

            const result = await response.json();

            if (result.error == "not_authorized") {
                CloseModal()
                setPopupMex({ active: true, type: "error", message: "Organization auth..." })
                setTimeout(() => {
                    setPopupMex({ active: false, type: null, message: "" })
                    navigate(`/e8console/organizations`)
                }, 5000);
            }

            if (!response.ok) throw new Error("Failed to deploy Ability");

            if (result.status == "success") {
                setStatusDelete(true)
                setTimeout(() => {
                    navigate(`/e8console/organizations/${org_id}/abilities`)
                    CloseModal()
                    if (fetchData){
                        fetchData(org_id)
                    }
                }, 4000);
            }
        } catch (err) {
            setErrorMessage({message: "An error occurred while deleting the Ability. Try again...", display: true})
            setLoadingDeleteMcp(false)
            setStatusDelete(false)
        }
    };

    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const CloseModal = () => {
        if (!statusDelete) {
            handleClose()
            setLoadingDeleteMcp(false)
            setErrorMessage({ message: "", display: false })
            setCheckedItems([false, false, false, false, false])
            setInputValue("")
        }
    }

    return (
        <Modal show={show} onHide={CloseModal} centered className="mcp_modal_custom">
            <div className="modal_header">
                {!statusDelete && (
                <p className="modal_header_title">
                    {t.abilities.delete_ability}
                </p>
                )}
            </div>

            {statusDelete ? (
                <div className="deleted_cont">
                    <div className="deleted_cont_inner">
                        <p className="deleted_cont_inner_title fade-in">{t.abilities.delete_success_title}</p>
                        <p className="deleted_cont_inner_subtitle fade-in">
                            {t.abilities.delete_success_subtitle}
                        </p>
                    </div>
                </div>
            ) : (
                <div className="deleted_cont fade-in">
                    <div className="delete_warning">
                        <div className="delete_warning_inner">
                            {t.abilities.warning_points.map((text, index) => (
                                <div
                                    key={index}
                                    className="delete_warning_inner_item"
                                    onClick={() => toggleCheck(index)}
                                >
                                    <i className={checkedItems[index] ? "delete_warning_inner_item_i_selected" : "delete_warning_inner_item_i"}>
                                        {checkedItems[index] ? <FaRegCircleCheck /> : <FaRegCircle />}
                                    </i>
                                    <p style={{ margin: 0 }}>{text}</p>
                                </div>
                            ))}
                        </div>
                        <p className="delete_warning_inner_p" dangerouslySetInnerHTML={{__html: t.abilities.delete_warning}}>
                        </p>
                    </div>
                    <div className="modal_profile_input_cont">
                        <div className="label_input">
                            <label className="input_label">
                                {t.type_confirm} "<strong>{mcp_id}</strong>"
                                <button className="path_item_root_btn" title="Copy" onClick={() => copyItem(mcp_id)}>{checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</button>

                            </label>
                            <input
                                type="text"
                                name="name"
                                maxLength={100}
                                placeholder={`${t.type_confirm} "${mcp_id}"`}
                                className="register_form_first fade-in"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
                {!statusDelete && (
                    <div className="modal_footer_btn_cont">
                        <button
                            className="modale_save_btn"
                            onClick={handleDeleteMcp}
                            disabled={statusDelete}
                        >
                            {loadingDeleteMcp ? <Spinner loading={true} /> : t.delete}
                        </button>
                        <button className="modale_close_btn" onClick={CloseModal}>
                            {t.close}
                        </button>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ConfirmDeleteMcpModal
    ;